import React, { useEffect, useState } from "react";
import axios from "../../api/axiosInstance";
import toast from "react-hot-toast";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import promoImage from "../../assets/crossed-swords-removebg.png";

const BlogMessage = () => {
  const [stories, setStories] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await axios.get("/api/stories-message/?page_size=100");
        setStories(res.data.results);
      } catch (err) {
        toast.error("Failed to load stories.");
      }
    };
    fetch();
  }, []);

  const window = stories.slice(-5); // Show last 5

  const NextArrow = ({ onClick }) => (
    <button
      className={`absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 text-white p-3 rounded-full hover:bg-black transition z-10 ${
        currentSlide === window.length - 1
          ? "opacity-30 cursor-not-allowed"
          : ""
      }`}
      onClick={currentSlide === window.length - 1 ? null : onClick}
    >
      <FaChevronRight size={20} />
    </button>
  );

  const PrevArrow = ({ onClick }) => (
    <button
      className={`absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 text-white p-3 rounded-full hover:bg-black transition z-10 ${
        currentSlide === 0 ? "opacity-30 cursor-not-allowed" : ""
      }`}
      onClick={currentSlide === 0 ? null : onClick}
    >
      <FaChevronLeft size={20} />
    </button>
  );

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (_, next) => setCurrentSlide(next),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: (dots) => (
      <div>
        <ul
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
          }}
        >
          {dots}
        </ul>
      </div>
    ),
    customPaging: () => (
      <div className="w-3 h-3 bg-gray-400 rounded-full hover:bg-green-500"></div>
    ),
  };

  return (
    <div className="max-w-4xl mx-auto py-8">
      <div className="flex items-center justify-center gap-3">
        <img src={promoImage} alt="Rajput Sword" className="h-8 w-8" />

        <h2 className="text-3xl font-extrabold text-[#800000] tracking-wide drop-shadow-md">
          Daily Updates
        </h2>

        <img src={promoImage} alt="Rajput Sword" className="h-8 w-8" />
      </div>

      <div className="flex items-center justify-center gap-3">
        <div className="h-1 w-1/3 bg-gradient-to-r from-[#800000] via-[#FFD700] to-[#800000] rounded-full shadow-md border border-yellow-300" />
      </div>

      {window.length === 0 ? (
        <p className="text-center text-gray-500">No stories to show.</p>
      ) : (
        <Slider {...settings}>
          {window.map((s) => {
            const dateOnly = s.created_at
              ? new Date(s.created_at).toLocaleDateString()
              : "";

            return (
              <div key={s.id} className="px-0">
                <div className="bg-white shadow-lg rounded-2xl overflow-hidden border border-gray-200 hover:shadow-2xl transition-shadow duration-300 relative pb-10">
                  {/* ✅ Headline & Date */}
                  <div className="flex justify-between items-center p-4 bg-green-50 border-b border-gray-200">
                    <h3 className="text-xl font-semibold text-gray-800">
                      {s.headline}
                    </h3>
                    <span className="text-sm text-gray-500">{dateOnly}</span>
                  </div>

                  {/* ✅ Media */}
                  {s.media && (
                    <div className="relative bg-black flex justify-center items-center">
                      {/\.(mp4|mov)$/i.test(s.media) ? (
                        <video
                          src={s.media}
                          controls
                          className="max-h-[450px] w-auto"
                        />
                      ) : (
                        <img
                          src={s.media}
                          alt="story media"
                          className="max-h-[450px] w-auto"
                        />
                      )}
                    </div>
                  )}

                  {/* ✅ Description */}
                  {s.description && (
                    <div className="p-5">
                      <p className="text-lg text-gray-700 leading-relaxed text-justify">
                        {s.description}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </Slider>
      )}
    </div>
  );
};

export default BlogMessage;
